<form class="form-b4a" [formGroup]="form" (submit)="refundProducts()">
  <span class="full-w form-b4a" formArrayName="items">
    <span
      class="full-w form-b4a"
      [formGroup]="item"
      *ngFor="let item of form.controls.items.controls; let i = index"
    >
      <span class="p-float-label">
        <p-dropdown
          [options]="availableItems[i]"
          optionLabel="productVariantName"
          optionValue="productVariantId"
          formControlName="productVariantId"
          (onChange)="setGlampoints(i)"
          [inputId]="'productVariantId' + i"
          [name]="'productVariantId' + i"
          [id]="'productVariantId' + i"
          appendTo="body"
        />
        <label [for]="'productVariantId' + i">Produto</label>
      </span>
      <span class="p-float-label">
        <p-inputNumber
          formControlName="glampoints"
          [inputId]="'glampoints' + i"
          [name]="'glampoints' + i"
          [id]="'glampoints' + i"
          [min]="1"
        />
        <label [for]="'glampoints' + i">Glampoints</label>
      </span>
    </span>
    <span>
      <p-button
        icon="pi pi-plus"
        size="small"
        type="button"
        (onClick)="addProduct()"
        severity="primary"
        [rounded]="true"
        pTooltip="Adicionar produto"
        *ngIf="hasProductToRefund"
      />
    </span>
  </span>
  <span class="totals">
    <span>Total Glampoints: {{ totalGlampoints | number: '1.0-2' }}</span>
  </span>
  <span class="buttons">
    <p-button label="Confirmar" type="submit" [disabled]="!form.valid" />
  </span>
</form>
